<template>
  <div class='analyze atb-flex atb-flex-column'>
    <div class='tab'>
      <tab-pane :tab-list="tabList" @getCurrent="getCurrent"></tab-pane>
    </div>
    <div v-show="currentTab == 0" class='container atb-flex'>
      <div class="chart atb-content-bg atb-flex atb-flex-column">
        <sub-title title="当年OEC比例分析"></sub-title>
        <div class="line" ref="line">

        </div>
      </div>
      <div class='table-content atb-content-bg atb-flex atb-flex-column'>
        <sub-title title="当年OEC比例统计"></sub-title>
        <div class="table-box">
          <vxe-table
            stripe
            class='atb-table header-table edit-table'
            border='inner'
            height='100%'
            auto-resize
            highlight-hover-row
            show-footer
            :data="tableData"
            :footer-method="footerMethod"
            ref="unHandle"
            >
            <!-- :footer-method="footerMethod" -->
          <vxe-table-column type="seq" width="50" title="NO."></vxe-table-column>
          <vxe-table-column field="date" title="时间" min-width="80">
            <template #default="{row}">{{row.date ? XEUtils.toDateString(new Date(row.date), 'yyyy-MM') : ''}}
            </template>
          </vxe-table-column>
          <vxe-table-column field="total" min-width="80" title="参评人数"></vxe-table-column>
          <vxe-table-column field="regulationA" min-width="70" title="规定A<=20%"></vxe-table-column>
          <vxe-table-column field="regulationC" min-width="60" title="规定C>=10%"></vxe-table-column>
          <vxe-table-column min-width="60" field="realityA" title="实际A人次">
            <template #default="{row}">
              <span>{{row.realityA}}</span>
            </template>
          </vxe-table-column>
          <vxe-table-column field="realityC" min-width="60" title="实际C人次"></vxe-table-column>
          <vxe-table-column field="realityProportionA" min-width="60" title="实际A比例"></vxe-table-column>
            <vxe-table-column field="realityProportionC" min-width="60" title="实际C比例"></vxe-table-column>
            <vxe-table-column field="moreThanA" min-width="60" title="超出A人次"></vxe-table-column>
          <vxe-table-column field="lessThanC" min-width="60" title="缺少C人次"></vxe-table-column>
        </vxe-table>
        </div>
      </div>
    </div>
    <div v-show="currentTab == 1" class='container atb-content-bg atb-flex atb-flex-column'>
      <div class='search'>
        <el-form :inline="true" :model="form" class="atb-input" @keyup.enter.native.prevent="getHistoryList('resetPage')" @submit.native.prevent>
          <el-form-item class="flex-form-item" label="部门名称" prop="departmentNo">
            <el-popover
              placement="bottom-start"
              width="420"
              popper-class="popper-tree declare-dep"
              @hide="handledHide"
              trigger="click">
              <el-tree
                :props="defaultProps"
                :data="treeData"
                show-checkbox
                node-key='id'
                ref="tree"
                highlight-current
                :default-expanded-keys="expandedData"
                @check="handleCheckChange">
              </el-tree>
              <el-input slot="reference" v-model="department" placeholder="请选择部门" clearable></el-input>
            </el-popover>
          </el-form-item>
          <el-form-item label="年份">
             <el-date-picker
               v-model="form.year"
               type="year"
               value-format="yyyy"
               placeholder="选择年"
               @change="yearChange"
              >
            </el-date-picker>
          </el-form-item>
          <el-form-item label="月份">
             <el-date-picker
               v-model="form.month"
               type="month"
               value-format="yyyy-MM"
               placeholder="选择月"
               @change="monthChange"
              >
            </el-date-picker>
          </el-form-item>
          <el-form-item class="flex-form-item" label="上级">
            <selecter v-model="form.SuperiorNo" placeholder="输入工号或姓名查询" :name="form.superiorName"></selecter>
          </el-form-item>
          <el-form-item label="异常A和C">
            <el-select clearable v-model="form.AC" placeholder="异常A和C">
              <el-option v-for="item in oecLevel" :key="item.value" :label="item.label" :value="item.value"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="数据权限" prop="AuthType">
            <el-select v-model="form.AuthType" placeholder="">
              <el-option v-for="item in authTypeList" :key="item.value" :label="item.label" :value="item.value"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="getHistoryList('resetPage')">查询</el-button>
          </el-form-item>
        </el-form>
      </div>
      <div class='table-content'>
        <vxe-table
          stripe
          class='atb-table'
          border='inner'
          height='100%'
          ref="handled"
          auto-resize
          highlight-hover-row
          :data="historyData"
          show-footer
          :footer-method="footerMethod"
        >
          <vxe-table-column type="seq" min-width="60" title="NO."></vxe-table-column>
          <vxe-table-column field="date" title="时间" min-width="80">
            <template #default="{row}">{{row.date ? XEUtils.toDateString(new Date(row.date), 'yyyy-MM') : ''}}
            </template>
          </vxe-table-column>
          <vxe-table-column field="total" min-width="60" title="参评人数"></vxe-table-column>
          <vxe-table-column field="regulationA" min-width="70" title="规定A<=20%"></vxe-table-column>
          <vxe-table-column field="regulationC" min-width="60" title="规定C>=10%"></vxe-table-column>
          <vxe-table-column min-width="60" field="realityA" title="实际A人次">
            <template #default="{row}">
              <span>{{row.realityA}}</span>
            </template>
          </vxe-table-column>
          <vxe-table-column field="realityC" min-width="60" title="实际C人次"></vxe-table-column>
          <vxe-table-column field="realityProportionA" min-width="60" title="实际A比例"></vxe-table-column>
            <vxe-table-column field="realityProportionC" min-width="60" title="实际C比例"></vxe-table-column>
            <vxe-table-column field="moreThanA" min-width="60" title="超出A人次"></vxe-table-column>
          <vxe-table-column field="lessThanC" min-width="60" title="缺少C人次"></vxe-table-column>
        </vxe-table>
      </div>
      <!-- <div class='page-con atb-flex atb-flex-justify-end'>
        <vxe-pager
          background
          :current-page.sync="historyPage.PageIndex"
          :page-size.sync="historyPage.PageSize"
          :total="historyTotal"
          height="100%"
          @page-change="historyPageChange"
          :layouts="['PrevJump', 'PrevPage', 'JumpNumber', 'NextPage', 'NextJump', 'Total']"
        >
        </vxe-pager>
      </div> -->
    </div>
    <el-dialog title="批量处理" :visible.sync="showHandle" width="260px" :close-on-click-modal="false" :close-on-press-escape="false">
      <div class="content">
        <h2>确定全部处理吗?</h2>
        <p>处理过之后就不能再修改</p>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button class="atb-dialog-confirm" type="primary" @click="confirmHandle">确认</el-button>
        <el-button class="atb-dialog-cancel" type="cancel" @click="showHandle = false">取消</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
  import _ from 'lodash';
  import XEUtils from 'xe-utils'
  export default {
    components:{
      selecter: () => import('@/component/global/customerSelect'),
    },
    name: "analyze",
    data() {
      return {
        XEUtils: XEUtils,
        activeName: 'second',
        currentTab: 0,
        showHandle: false,
        handleDelete: true,
        enableHandle: true,
        tabList: [
          {
            label: '当年比例分析',
            id: 0,
          },
          {
            label: '历史查询',
            id: 1,
          },
        ],
        importantList: [
          {label: '否', value: false},
          {label: '是', value: true},
        ],
        oecLevel: [
          {label: '超出A人数', value: 1},
          {label: '缺少C人数', value: 2},
          {label: '全部', value: 0},
        ],

        form: {
          year:'',
          month: '',
          WkName: '',
          AC: 0,
          AuthType: 0,
        },
        historyPage: {
          PageIndex: 1,
          PageSize: 20
        },
        historyTotal: 0,
        historyData: [],

        page: {
          PageIndex: 1,
          PageSize: 20
        },
        total: 0,
        tableData: [],

        unHandleList: [],
        handledList: [],
        treeData: [],
        expandedData:[],
        defaultProps: {
          children: 'children',
          label: 'label'
        },
        department:'',
        departmentNo:'',

        authTypeList: [
          { label: '直属下级', value: 0 },
          { label: '全部下级', value: 1 },
          { label: '数据权限', value: 2 },
          { label: '全部', value: 3 },
        ],
      }
    },
    created() {

    },
    mounted() {
      this.getDep();
      this.getList();
      this.getHistoryList();
    },
    methods: {
      handleClick(tab, event) {
        console.log(tab, event);
      },
      getList() {
        let chart = window.echarts.init(this.$refs.line);
        let option = {
          title: {
            text: ''
          },
          tooltip: {
            trigger: 'axis',
          },
          color:['#ff6e6e', '#7d96e3', '#d9b974', '#14b297'],
          legend: {
            right: 0,
            data: [
              {name: '规定C人次', icon: 'path://M0 10L6 10L6 11L0 11ZM8 10L14 10L14 11L8 11Z'},
              {name: '规定A人次', icon: 'path://M0 10L6 10L6 11L0 11ZM8 10L14 10L14 11L8 11Z'},
              {name: '实际C人次'},
              {name: '实际A人次'},
            ]
          },
          grid: {
            left: '3%',
            right: '4%',
            bottom: '3%',
            containLabel: true
          },
          xAxis: {
            type: 'category',
            boundaryGap: false,
            data: ['1月', '2月', '3月', '4月']
          },
          yAxis: {
            type: 'value'
          },
          series: [
            {
              name: '规定C人次',
              type: 'line',
              symbol: 'none',
              lineStyle:{
                width: 2,
                type: 'dashed',
                emphasis: {
                  width: 2
                }
              },
              data: []
            },
            {
              name: '规定A人次',
              type: 'line',
              symbol: 'none',
              lineStyle:{
                width: 2,
                type: 'dashed',
                emphasis: {
                  width: 2
                }
              },
              data: []
            },
            {
              name: '实际C人次',
              type: 'line',
              symbolSize: 8,
              // lineStyle:{
              //   color:'#39d5ff'
              // },
              data: []
            },
            {
              name: '实际A人次',
              type: 'line',
              symbolSize: 8,
              // lineStyle:{
              //   color:'#45efb7'
              // },
              data: []
            },
          ]
        };

        this.$ajax.get(this.$api.manage.declare.analyzeDefault).then((res) => {
          this.tableData = res.data.rows.oecResultAnalyzeList;
          let regulationA = [];
          let regulationC = [];
          let realityA = [];
          let realityC = [];
          let month = [];
          this.tableData.forEach(val => {
            regulationA.push(val.regulationA);
            regulationC.push(val.regulationC);
            realityA.push(val.realityA);
            realityC.push(val.realityC);
            month.push(XEUtils.toDateString(new Date(val.date), 'yyyy-MM').split('-')[1] + '月');
          });
          option.xAxis.data = month;
          option.series[0].data = regulationC;
          option.series[1].data = regulationA;
          option.series[2].data = realityC;
          option.series[3].data = realityA;
          chart.setOption(option);
        });
      },
      getHistoryList(resetPage) {
        if(resetPage){
          this.historyPage.PageIndex = 1;
        }
        let param = Object.assign({}, this.historyPage, this.form,{departmentNo: this.departmentNo});
        this.$ajax.get(this.$api.manage.declare.analyze, param).then((res) => {
          this.historyData = res.data.rows.oecResultAnalyzeList;
          this.historyTotal = res.data.total;
        });
      },
      getCurrent(item) {
        this.currentTab = item.data.id;
      },
      editClosed({row}){
        this.$ajax.post(this.$api.manage.declare.create, row).then(() => {
          this.$message.success("保存成功");
        });
      },
      editActived({row}) {
        if(row.status === 10){
          return false;
        }
        return true;
      },
      save() {
        this.$ajax.post(this.$api.manage.declare.createAll, this.unHandleList).then(() => {
          this.$message.success("保存成功");
        });
      },
      submit() {
        let arr = this.unHandleList.map(val => val.id);
        if(arr.length){
          const ids = arr.join(",");
          this.$ajax.put(this.$api.manage.declare.submit, {ids: ids}).then(() => {
            this.$message.success("提交成功");
          });
        }else {
          this.$message.error("请选择后提交数据");
        }
      },
      unHandleSelectAll({records}) {
        this.unHandleList = records;
      },
      unHandleSelectChange({records}) {
        this.unHandleList = records;
      },
      pageChange({ currentPage }) {
        this.page.PageIndex = currentPage;
        this.getList();
      },
      historyPageChange({ currentPage }) {
        this.historyPage.PageIndex = currentPage;
        this.getHistoryList();
      },
      async getDep() {
       await this.$ajax.get(this.$api.Identity.Categord.dep, {}).then(res => {
          this.depList=res.data||[];     
            const obj ={};
            this.depList.forEach(v=>{
             const objClone=_.cloneDeep(obj);
             objClone.id= v.id,
             objClone.code= v.code,
             objClone.label= v.displayName
           if(v.parentId===null){
              this.expandedData.push(v.id);
              objClone.children= this.depList.filter(t=>t.parentId===v.id);
              this.generateMenu(objClone.children);
              this.treeData.push(objClone);
            }
          });
        });
      },
      generateMenu(chs){
        chs.forEach(v=>{
          v.label= v.displayName
          v.children = this.depList.filter(t=>t.parentId === v.id)
          this.generateMenu(v.children);
        });
      },
      handleCheckChange(){
        this.selectNode = this.getSimpleCheckedNodes(this.$refs.tree.store);
        let code = [] , deptNmae = [];
        this.selectNode.forEach(t => {
          code.push(t.code);
          deptNmae.push(t.label);
        });
        this.departmentNo = code.join(",");
        this.department = deptNmae.join(",");
      },
      getSimpleCheckedNodes(store) {
        const checkedNodes = [];
        const traverse = function(node) {
          const childNodes = node.root ? node.root.childNodes : node.childNodes;
          childNodes.forEach(child => {
            if (child.checked) {
              checkedNodes.push(child.data);
            }
            if (child.indeterminate) {
              traverse(child);
            }
          });
        };
        traverse(store)
        return checkedNodes;
      },
      monthChange(month) {
        if (month) {
          const year = month.split('-')[0];
          if (this.form.year != year) {
            this.form.year = year;
          }
        }
      },
      yearChange(year) {
        if (year) {
          this.form.month = '';
        }
      },
      formatNumber(num) {
        const rounded = _.round(num, 2);
        if (Number.isInteger(rounded)) {
          return rounded.toString(); // 整数不显示小数部分
        } else {
          return rounded.toFixed(2); // 非整数保留两位小数
        }
      },
      totalNum(list, field) {
        let count = 0
        list.forEach(item => {
          count += Number(item[field])
        })
        return this.formatNumber(count)
      },
      footerMethod({columns, data}) {
        if (data.length === 0) return [];
        const totalRow = {
          seq: '合计',
        }
        const cols = ['seq', 'date', 'total', 'regulationA', 'regulationC', 'realityA', 'realityC', 'realityProportionA', 'realityProportionC', 'moreThanA', 'lessThanC']
        columns.forEach((column) => {
          if (column.type !== 'seq') {
            switch (column.property) {
              case 'total':
              case 'regulationA':
              case 'regulationC':
              case 'realityA':
              case 'realityC':
              case 'realityProportionA':
              case 'realityProportionC':
              case 'moreThanA':
              case 'lessThanC':
                totalRow[column.property] = this.totalNum(data, column.property)
                break
              case 'date':
                const row = data[0];
                totalRow['date'] = XEUtils.toDateString(new Date(row.date), 'yyyy')
                break
            }
          }
        })
        return [cols.map(item => totalRow[item] || 0)]
      }
    },
    watch: {
      department: {
        handler(val){
          if(!val){
            this.departmentNo = "";
            this.$refs.tree && this.$refs.tree.setCheckedKeys([]);
          }
        },
        immediate:true
      }
    }
  }
</script>
<style scoped lang='scss'>
  .analyze {
    height: 100%;
    ::v-deep .tab{
      margin-top: -3px;
    }
    .container{
      flex: 1;
      margin-top: 15px;
      overflow: auto;
      .chart{
        flex: 4;
        margin-right: 20px;
        .line{
          flex-grow: 1;
        }
      }
      .table-content{
        flex: 5;
        .table-box{
          flex-grow: 1;
          overflow: auto;
        }
      }
    }
  }
</style>